import apiClient from './axios';

const securityQuestionApi = {
  /** GET /api/questions/ */
  getAll: async () => {
    const response = await apiClient.get('/questions/', {
      headers: { Authorization: '' }, // public endpoint
    });
    return response.data || [];
  },

  /** 
   * POST /password/verify-security 
   * Updated to match your specific API spec 
   */
  verify: async (employeeCode, answersArray) => {
    // answersArray is expected to be: [{ question_id: "...", answer: "..." }, ...]
    const payload = {
      code: employeeCode,
      answers: answersArray.map((item) => ({
        // FIX: Spec requires "question_id", not "question"
        question_id: item.question_id, 
        answer: item.answer
      })),
    };

    // FIX: Updated URL to match your spec (/password/verify-security)
    const response = await apiClient.post('/password/verify-security', payload, {
      headers: { Authorization: '' }, // public endpoint
    });

    return response.data;
  },

  /** POST /api/first-login/ – first-time setup */
  firstLoginSetup: async (answers) => {
    const payload = {
      answers: answers.map(([question, answer]) => ({ question, answer })),
    };

    const r = await apiClient.patch('/first-login/', payload);
    return r.data;
  },
};

export default securityQuestionApi;